import { createSlice } from '@reduxjs/toolkit';
import getAdapter from './getAdapter';

const quoteTypesAdapter = getAdapter({ idFieldName: 'value' });

const quoteTypesSlice = createSlice({
  name: 'quoteTypes',
  initialState: quoteTypesAdapter.getInitialState(),
  reducers: {
    setQuoteTypes: (state, { payload: { quoteTypes } }) => {
      quoteTypesAdapter.setAll(state, quoteTypes);
    },
  },
});

const selectors = quoteTypesAdapter.getSelectors(({ quoteTypes }) => quoteTypes);

export const getQuoteTypes = (state) => selectors.selectAll(state);

export const {
  setQuoteTypes,
} = quoteTypesSlice.actions;

export default quoteTypesSlice.reducer;
